module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadTasks),
      expression: "loadTasks"
    }],
    staticClass: "task-list",
    attrs: {
      "id": "tasks",
      "infinite-scroll-distance": "10"
    }
  }, [_vm._l((_vm.tasks), function(task, index) {
    return [(task.contact) ? _c('done-task-item', {
      key: task.id,
      attrs: {
        "task": task
      },
      on: {
        "toggle-task-bar": _vm.bubbleUp,
        "task-updated": _vm.taskUpdated
      }
    }) : _vm._e()]
  }), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text",
    attrs: {
      "id": "no-more-results"
    }
  }, [_vm._v("Sem mais resultados")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9b328a4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/done_tasks/list.vue
// module id = 1197
// module chunks = 1